import { render } from "./ManageDistributors.vue?vue&type=template&id=0b21629e"
import script from "./ManageDistributors.vue?vue&type=script&lang=js"
export * from "./ManageDistributors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__